import { createSelector } from 'reselect';
import { AppState } from 'state/state.model';
import { BatchWorkspaceShortcutCheatsheetBannerState } from 'state/workspaces/batch/shortcutCheatsheetBanner/shortcutCheatsheetBanner.model';

function selectBatchWorkspaceShortcutCheatsheetBannerState(
  state: AppState,
): BatchWorkspaceShortcutCheatsheetBannerState {
  return state.workspaces.newBatch.shortcutCheatsheetBanner;
}
export const getIsCheatsheetBannerClosed = createSelector(
  selectBatchWorkspaceShortcutCheatsheetBannerState,
  state => state.IsCheatsheetBannerClosed ?? false,
);
